<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Rozliczenia'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-settlement-details-view
      [commissionSettlement]="commissionSettlement"
    ></app-settlement-details-view>
  </mat-tab>
  <mat-tab label="Prowizje">
    <ng-template matTabContent>
      <app-all-commissions-list
        [embeddedView]="true" [commissionSettlement]="commissionSettlementObject.uuid"
        [enableFilters]="[
          'insuranceCompany', 'importer', 'policyNumber', 'company', 'ofwca', 'collection',
          'partnerAssetsRegional', 'ofwcaAssetsRegional', 'notMatched', 'matched', 'contract',
          'createdAt', 'risk', 'status',
        ]"
      ></app-all-commissions-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
